import { render, staticRenderFns } from "./RunJavaScriptAttributePicker.vue?vue&type=template&id=6bd96b4f&scoped=true"
import script from "./RunJavaScriptAttributePicker.vue?vue&type=script&lang=js"
export * from "./RunJavaScriptAttributePicker.vue?vue&type=script&lang=js"
import style0 from "./RunJavaScriptAttributePicker.vue?vue&type=style&index=0&id=6bd96b4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd96b4f",
  null
  
)

export default component.exports